export { VehicleTypeAsset, type VehicleTypeAssetProps } from './VehicleTypeAsset';
